// extracted by mini-css-extract-plugin
module.exports = {"logoDark":"LogoDark_logoDark__KldS2"};